module.exports = __webpack_public_path__ + "img/denmark-respiratory-diseases-female.ccc2d1bf.png";